import { BasicOptionCheckState, ChoiceOptionState } from '../../../classes/learnware/LearnwareEnums';
export class SelectOptionUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get option() {
        return this.parent;
    }
    get shouldOptionBeGreen() {
        return [
            ChoiceOptionState.CorrectDone,
            ChoiceOptionState.CorrectPending,
            ChoiceOptionState.ShouldHaveBeenSelected
        ].includes(this.choiceOptionUIState);
    }
    get choiceOptionUIState() {
        if (this.option.context.app.appInfo.isUserCurrentlyEditing) {
            return this.option.shouldBeSelected ? ChoiceOptionState.CorrectPending : ChoiceOptionState.Default;
        }
        if (this.option.isCorrectlySelected && this.option.selectTask.taskProgress.isTaskComplete) {
            return ChoiceOptionState.CorrectDone;
        }
        if (this.option.isCorrectlySelected && !this.option.selectTask.taskProgress.isTaskComplete) {
            return ChoiceOptionState.CorrectPending;
        }
        if (this.option.isWronglySelected)
            return ChoiceOptionState.Wrong;
        if (this.option.selectTask.taskProgress.isTaskComplete && this.option.isOpenToBeSelected) {
            return ChoiceOptionState.ShouldHaveBeenSelected;
        }
        return ChoiceOptionState.Default;
    }
    get choiceOptionUICheckState() {
        if (this.option.context.app.appInfo.isUserCurrentlyEditing) {
            return this.option.shouldBeSelected ? BasicOptionCheckState.Correct : BasicOptionCheckState.Default;
        }
        if (this.option.isCorrectlySelected)
            return BasicOptionCheckState.Correct;
        if (this.option.isWronglySelected)
            return BasicOptionCheckState.Wrong;
        return BasicOptionCheckState.Default;
    }
}
